import React from 'react';
import Loadable from 'react-loadable';

const ParagraphSlider = Loadable({
  loader: () => import('./index.lazy'),
  loading: () => (<div />),
  delay: 1500,
});

export default ParagraphSlider;
